import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRomance = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3518 25C14.5369 27.3912 16.3336 29 16.3336 29C16.3336 29 18.1302 27.3912 19.3153 25M6.85221 18C4.06865 14.9398 4.34077 10.0073 4.34077 10.0073C4.34077 10.0073 9.27326 9.73516 12.3335 12.5187M25.8148 18C28.5983 14.9398 28.3262 10.0073 28.3262 10.0073C28.3262 10.0073 23.3937 9.73516 20.3335 12.5187M16.3335 22C16.3335 22 20.3335 18.4183 20.3335 14C20.3335 9.58172 16.3335 6 16.3335 6C16.3335 6 12.3335 9.58172 12.3335 14C12.3335 18.4183 16.3335 22 16.3335 22ZM16.3335 22C16.3335 22 12.9756 18 8.8335 18C4.69136 18 1.3335 22 1.3335 22C1.3335 22 4.69136 26 8.8335 26C12.9756 26 16.3335 22 16.3335 22ZM16.3335 22C16.3335 22 19.6914 26 23.8335 26C27.9756 26 31.3335 22 31.3335 22C31.3335 22 27.9756 18 23.8335 18C19.6914 18 16.3335 22 16.3335 22ZM11.3335 5H11.3835M21.3335 5H21.3835M16.3335 2H16.3835",
		stroke: "#FF537F",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRomance;
